import React, { useState } from "react";
import { Link } from "react-router-dom";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(
      `Form Submitted!\nName: ${formData.name}\nEmail: ${formData.email}\nMessage: ${formData.message}`
    );
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="bg-white text-gray-800">
      <div
        className="relative w-full h-[150px] sm:h-[200px] md:h-[250px] mb-3 bg-cover bg-center overflow-hidden"
        style={{
          backgroundImage: `url(${require("../../assets/images/products/bag.jpg")})`,
        }}
      >
        {/* Black overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center text-white text-center p-4">
          {/* Page Title */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl  mb-2 uppercase tracking-wide">
            Contact Us
          </h2>

          {/* Breadcrumb */}
          <nav className="flex items-center space-x-2 text-sm text-gray-200 bg-black/40 px-4 py-2 rounded-md max-w-fit mx-auto">
            <Link to="/" className="hover:text-white">
              Home
            </Link>
            <span>/</span>
            <span>Contact Us</span>
          </nav>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 border">
        {/* ====== Contact Form ====== */}
        <form onSubmit={handleSubmit} className="max-w-2xl mx-auto space-y-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Name"
              required
              className="w-full bg-transparent border-b border-gray-300 py-2 focus:outline-none focus:border-black transition-colors"
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="E-mail"
              required
              className="w-full bg-transparent border-b border-gray-300 py-2 focus:outline-none focus:border-black transition-colors"
            />
          </div>

          <div>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              placeholder="Message"
              required
              rows={5}
              className="w-full bg-transparent border-b border-gray-300 py-2 focus:outline-none focus:border-black transition-colors resize-none"
            />
          </div>

          <div className="text-center pt-4">
            <button
              type="submit"
              className="bg-black text-white font-semibold tracking-widest uppercase px-12 py-3 hover:bg-gray-800 transition-colors duration-300"
            >
              SEND MESSAGE
            </button>
          </div>
        </form>
      </div>

      {/* ====== Map Section ====== */}
      <section className="mt-20">
        <div className="w-full">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d117474.25856897957!2d72.45213789625319!3d23.057873846521158!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x395e84a78fd6e6dd%3A0x1a609dcf82824e39!2sG%2014%2C%20Smita%20Tower%2C%20Gurukul%20Rd%2C%20opposite%20Green%20Villa%2C%20near%20Vishramnagar%2C%20Memnagar%2C%20Ahmedabad%2C%20Gujarat%20380052!3m2!1d23.057895199999997!2d72.5345395!5e0!3m2!1sen!2sin!4v1755712986313!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Our Location"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
